// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saving-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  margin-bottom: 12px;
  background: rgba(0, 102, 178, 0.08);
  border: 1px solid rgba(0, 102, 178, 0.2);
  border-radius: 8px;
  color: #0066B2;
  font-size: 13px;
  font-weight: 500;
}
.saving-indicator i {
  font-size: 16px;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.sidebar-overlay.active {
  opacity: 1;
  visibility: visible;
}

.help-sidebar {
  position: fixed;
  top: 0;
  right: -450px;
  width: 450px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
}
.help-sidebar.open {
  right: 0;
}
.help-sidebar .sidebar-header {
  background: #0066B2;
  color: white;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
}
.help-sidebar .sidebar-header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%);
}
.help-sidebar .sidebar-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.help-sidebar .sidebar-header .close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.help-sidebar .sidebar-header .close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg) scale(1.1);
  border-color: rgba(255, 255, 255, 0.3);
}
.help-sidebar .sidebar-header .close-btn:active {
  transform: rotate(90deg) scale(0.95);
}
.help-sidebar .sidebar-header .close-btn i {
  line-height: 1;
}
.help-sidebar .sidebar-content {
  padding: 24px 20px;
  overflow-y: auto;
  flex: 1;
}
.help-sidebar .sidebar-content .greeting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.help-sidebar .sidebar-content .greeting-row h3 {
  margin: 0;
  font-size: 18px;
  color: #3a3a3a;
  font-weight: 500;
}
.help-sidebar .sidebar-content .greeting-row .greeting-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.help-sidebar .sidebar-content .greeting-row .add-tutorial-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 178, 0.3);
  background: rgba(0, 102, 178, 0.08);
  color: #0066B2;
  cursor: pointer;
  transition: all 0.25s ease;
  flex-shrink: 0;
}
.help-sidebar .sidebar-content .greeting-row .add-tutorial-btn i {
  font-size: 14px;
}
.help-sidebar .sidebar-content .greeting-row .add-tutorial-btn:hover {
  background: #0066B2;
  color: white;
  border-color: #0066B2;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 102, 178, 0.3);
}
.help-sidebar .sidebar-content .greeting-row .add-tutorial-btn:active {
  transform: scale(0.95);
}
.help-sidebar .sidebar-content .greeting-row .refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 178, 0.2);
  background: rgba(0, 157, 217, 0.06);
  color: #0066B2;
  cursor: pointer;
  transition: all 0.25s ease;
  flex-shrink: 0;
}
.help-sidebar .sidebar-content .greeting-row .refresh-btn i {
  font-size: 15px;
}
.help-sidebar .sidebar-content .greeting-row .refresh-btn:hover:not(:disabled) {
  background: rgba(0, 102, 178, 0.1);
  border-color: #0066B2;
  transform: rotate(45deg);
  box-shadow: 0 2px 8px rgba(0, 102, 178, 0.15);
}
.help-sidebar .sidebar-content .greeting-row .refresh-btn:active:not(:disabled) {
  transform: rotate(90deg) scale(0.95);
}
.help-sidebar .sidebar-content .greeting-row .refresh-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.help-sidebar .sidebar-content .search-container {
  margin-bottom: 28px;
  position: relative;
}
.help-sidebar .sidebar-content .search-container .p-input-icon-left {
  width: 100%;
  display: block;
  position: relative;
}
.help-sidebar .sidebar-content .search-container .p-input-icon-left > i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #0066B2;
  font-size: 16px;
  z-index: 1;
  pointer-events: none;
}
.help-sidebar .sidebar-content .search-container .search-clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #777;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 2;
}
.help-sidebar .sidebar-content .search-container .search-clear-btn i {
  font-size: 12px;
  pointer-events: none;
}
.help-sidebar .sidebar-content .search-container .search-clear-btn:hover {
  color: #0B2D71;
  background: rgba(0, 102, 178, 0.1);
}
.help-sidebar .sidebar-content .search-container .search-input {
  width: 100%;
  padding: 12px 36px 12px 44px;
  border: 2px solid #EFEFEF;
  border-radius: 12px;
  font-size: 14px;
  background-color: #f8f9fa;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.help-sidebar .sidebar-content .search-container .search-input:hover {
  border-color: rgb(25, 156.797752809, 255);
  background-color: white;
}
.help-sidebar .sidebar-content .search-container .search-input:focus {
  outline: none;
  border-color: #0066B2;
  background-color: white;
  box-shadow: 0 0 0 4px rgba(0, 102, 178, 0.1);
}
.help-sidebar .sidebar-content .tutorial-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip {
  cursor: pointer;
  border: 1.5px solid #EFEFEF;
  border-radius: 20px;
  background: #f8f9fa;
  color: #3a3a3a;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 14px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
          user-select: none;
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip .p-chip-icon {
  font-size: 13px;
  margin-right: 6px;
  color: #0066B2;
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip .p-chip-text {
  line-height: 1.4;
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip:hover {
  border-color: #0066B2;
  background: rgba(0, 102, 178, 0.06);
  color: #0066B2;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 102, 178, 0.12);
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip.active {
  background: linear-gradient(135deg, #0066B2 0%, #0B2D71 100%);
  border-color: #0066B2;
  color: white;
  box-shadow: 0 2px 12px rgba(0, 102, 178, 0.25);
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip.active .p-chip-icon {
  color: white;
}
.help-sidebar .sidebar-content .tutorial-cards ::ng-deep .tutorial-card-chip.active:hover {
  box-shadow: 0 4px 16px rgba(0, 102, 178, 0.35);
  transform: translateY(-1px);
}
.help-sidebar .sidebar-content .about-panel {
  background: rgba(0, 102, 178, 0.04);
  border: 1px solid rgba(0, 102, 178, 0.15);
  border-radius: 10px;
  padding: 20px 22px;
  margin-bottom: 24px;
}
.help-sidebar .sidebar-content .about-panel .about-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.help-sidebar .sidebar-content .about-panel .about-header i {
  font-size: 20px;
  color: #0066B2;
}
.help-sidebar .sidebar-content .about-panel .about-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #3a3a3a;
}
.help-sidebar .sidebar-content .about-panel p {
  margin: 0 0 12px;
  font-size: 13.5px;
  line-height: 1.65;
  color: #3a3a3a;
}
.help-sidebar .sidebar-content .about-panel p:last-child {
  margin-bottom: 0;
}
.help-sidebar .sidebar-content .about-panel .about-note {
  font-style: italic;
  color: #777;
  font-size: 12.5px;
}
.help-sidebar .sidebar-content .skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.help-sidebar .sidebar-content .skeleton-list .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card {
  border: 1px solid rgba(0, 102, 178, 0.12);
  border-radius: 12px;
  padding: 14px 16px;
  border-left: 4px solid rgba(0, 102, 178, 0.3);
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card .skeleton-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card .skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #EFEFEF 25%, #e8e8e8 50%, #EFEFEF 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s ease-in-out infinite;
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card .skeleton-title {
  height: 14px;
  width: 60%;
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card .skeleton-badge {
  height: 12px;
  width: 55px;
}
.help-sidebar .sidebar-content .skeleton-list .skeleton-card .skeleton-desc {
  height: 12px;
  width: 85%;
}
@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.help-sidebar .sidebar-content .error-state {
  text-align: center;
  padding: 40px 20px;
  color: #e74c3c;
}
.help-sidebar .sidebar-content .error-state i {
  font-size: 40px;
  margin-bottom: 16px;
  display: block;
  opacity: 0.8;
}
.help-sidebar .sidebar-content .error-state p {
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #777;
  line-height: 1.5;
}
.help-sidebar .sidebar-content .error-state .retry-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #0066B2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.help-sidebar .sidebar-content .error-state .retry-btn:hover {
  background: #0B2D71;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 102, 178, 0.3);
}
.help-sidebar .sidebar-content .error-state .retry-btn:active {
  transform: translateY(0);
}
.help-sidebar .sidebar-content .error-state .retry-btn i {
  font-size: 14px;
  margin-bottom: 0;
  color: white;
  opacity: 1;
}
.help-sidebar .sidebar-content .tutorials-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card {
  border: 1px solid rgba(0, 102, 178, 0.2);
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(135deg, rgba(0, 157, 217, 0.04), rgba(0, 102, 178, 0.06));
  position: relative;
  overflow: hidden;
  border-left: 4px solid #0066B2;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card mark {
  background-color: rgba(0, 157, 217, 0.25);
  color: #0B2D71;
  padding: 1px 2px;
  border-radius: 2px;
  font-weight: 600;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 157, 217, 0.08) 50%, transparent 100%);
  transition: left 0.5s ease;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card:hover {
  border-color: #0066B2;
  border-left-color: #0B2D71;
  box-shadow: 0 8px 24px rgba(11, 45, 113, 0.18), 0 4px 12px rgba(0, 102, 178, 0.12);
  background: linear-gradient(135deg, rgba(0, 157, 217, 0.08), rgba(0, 102, 178, 0.12));
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card:hover::before {
  left: 100%;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row h4 {
  margin: 0;
  font-size: 15px;
  color: #0B2D71;
  font-weight: 600;
  flex: 1;
  min-width: 0;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .card-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .steps-count {
  font-size: 12px;
  color: #0066B2;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .steps-count i {
  font-size: 13px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .card-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #777;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0;
  padding: 0;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .card-action-btn i {
  font-size: 13px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .card-action-btn:hover {
  background: rgba(0, 102, 178, 0.1);
  color: #0066B2;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .card-action-btn.delete:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .video-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid rgba(0, 102, 178, 0.3);
  background: transparent;
  color: #0066B2;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 0 0 2px;
  box-sizing: border-box;
  text-decoration: none;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .video-btn i {
  font-size: 11px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .video-btn:hover {
  background: rgba(0, 102, 178, 0.1);
  border-color: #0066B2;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .visibility-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #777;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .visibility-toggle-btn i {
  font-size: 13px;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .visibility-toggle-btn:hover {
  background: rgba(0, 102, 178, 0.1);
  color: #0066B2;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .visibility-toggle-btn.published {
  color: #2e9e5b;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-header-row .visibility-toggle-btn.published:hover {
  background: rgba(46, 158, 91, 0.12);
  color: #2e9e5b;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card:hover .card-header-row .card-action-btn {
  opacity: 1;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card p {
  margin: 0;
  font-size: 13px;
  color: #777;
  line-height: 1.5;
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-footer {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 102, 178, 0.08);
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-footer .draft-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #b26a00;
  background: rgba(245, 166, 35, 0.15);
}
.help-sidebar .sidebar-content .tutorials-list .tutorial-card .card-footer .draft-badge i {
  font-size: 11px;
}
.help-sidebar .sidebar-content .no-results {
  text-align: center;
  padding: 40px 20px;
  color: #777;
}
.help-sidebar .sidebar-content .no-results i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}
.help-sidebar .sidebar-content .no-results p {
  margin: 0;
  font-size: 16px;
}
.help-sidebar .sidebar-content .tutorial-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .back-btn {
  background: none;
  border: none;
  color: #0066B2;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .back-btn:hover {
  color: #0B2D71;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .back-btn i {
  font-size: 14px;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn {
  background: rgba(0, 102, 178, 0.08);
  border: 1px solid rgba(0, 102, 178, 0.15);
  border-radius: 50%;
  color: #0066B2;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  transition: all 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn:hover {
  background: rgba(0, 102, 178, 0.15);
  border-color: #0066B2;
  transform: scale(1.1);
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn.delete {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.06);
  border-color: rgba(231, 76, 60, 0.15);
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn.delete:hover {
  background: rgba(231, 76, 60, 0.12);
  border-color: #e74c3c;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn.video {
  box-sizing: border-box;
  text-decoration: none;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .detail-action-btn i {
  font-size: 14px;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .visibility-toggle-btn.detail {
  background: rgba(0, 102, 178, 0.08);
  border: 1px solid rgba(0, 102, 178, 0.15);
  border-radius: 50%;
  color: #0066B2;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  transition: all 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .visibility-toggle-btn.detail:hover {
  background: rgba(0, 102, 178, 0.15);
  border-color: #0066B2;
  transform: scale(1.1);
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .visibility-toggle-btn.detail.published {
  color: #2e9e5b;
  background: rgba(46, 158, 91, 0.08);
  border-color: rgba(46, 158, 91, 0.2);
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .visibility-toggle-btn.detail.published:hover {
  background: rgba(46, 158, 91, 0.15);
  border-color: #2e9e5b;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .visibility-toggle-btn.detail i {
  font-size: 14px;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .zoom-btn {
  background: rgba(0, 102, 178, 0.08);
  border: 1px solid rgba(0, 102, 178, 0.15);
  border-radius: 50%;
  color: #0066B2;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  transition: all 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .zoom-btn:hover {
  background: rgba(0, 102, 178, 0.15);
  border-color: #0066B2;
  transform: scale(1.1);
}
.help-sidebar .sidebar-content .tutorial-detail .detail-top-bar .zoom-btn i {
  font-size: 14px;
}
.help-sidebar .sidebar-content .tutorial-detail .tutorial-title {
  margin: 0 0 16px 0;
  font-size: 22px;
  color: #3a3a3a;
  font-weight: 600;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-counter {
  font-size: 12px;
  font-weight: 600;
  color: #0066B2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-title-label {
  font-size: 15px;
  font-weight: 600;
  color: #3a3a3a;
  flex: 1;
  min-width: 0;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions .step-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(0, 102, 178, 0.15);
  background: rgba(0, 102, 178, 0.06);
  color: #0066B2;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions .step-action-btn i {
  font-size: 12px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions .step-action-btn:hover {
  background: rgba(0, 102, 178, 0.15);
  border-color: #0066B2;
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions .step-action-btn.delete {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.04);
  border-color: rgba(231, 76, 60, 0.15);
}
.help-sidebar .sidebar-content .tutorial-detail .step-indicator .step-admin-actions .step-action-btn.delete:hover {
  background: rgba(231, 76, 60, 0.12);
  border-color: #e74c3c;
}
.help-sidebar .sidebar-content .tutorial-detail .step-progress-bar {
  height: 3px;
  background: #EFEFEF;
  border-radius: 2px;
  margin-bottom: 20px;
  overflow: hidden;
}
.help-sidebar .sidebar-content .tutorial-detail .step-progress-bar .step-progress-fill {
  height: 100%;
  background: #0066B2;
  border-radius: 2px;
  transition: width 0.3s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-header {
  margin-bottom: 12px;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-header .reorder-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #3a3a3a;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-header .reorder-title i {
  color: #0066B2;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-header .reorder-hint {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #777;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 2px;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 178, 0.15);
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: default;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item.cdk-drag-preview {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item.cdk-drag-placeholder {
  opacity: 0.4;
  border-style: dashed;
  background: rgba(0, 102, 178, 0.06);
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item .reorder-handle {
  font-size: 14px;
  color: #777;
  cursor: grab;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item .reorder-handle:active {
  cursor: grabbing;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item .reorder-item-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 102, 178, 0.1);
  color: #0066B2;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-item .reorder-item-title {
  font-size: 14px;
  color: #3a3a3a;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .cdk-drag-animating {
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1);
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-cancel,
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-save {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-cancel {
  background: #fff;
  border-color: #EFEFEF;
  color: #3a3a3a;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-cancel:hover {
  background: #EFEFEF;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-save {
  background: #0066B2;
  color: #fff;
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-save:hover:not(:disabled) {
  background: rgb(0, 78.6202247191, 137.2);
}
.help-sidebar .sidebar-content .tutorial-detail .reorder-panel .reorder-actions .btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content {
  flex: 1;
  overflow-y: auto;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body {
  font-size: 14px;
  color: #3a3a3a;
  line-height: 1.4;
  margin-bottom: 16px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep b, .help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep strong {
  font-weight: 600;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep u {
  text-decoration: underline;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep p {
  margin: 0;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep p:last-child {
  margin-bottom: 0;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep ul, .help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep ol {
  margin: 0 0 12px 0;
  padding-left: 24px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep i, .help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep em {
  font-style: italic;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep .ql-align-center {
  text-align: center;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep .ql-align-right {
  text-align: right;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep .ql-align-justify {
  text-align: justify;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-body ::ng-deep code {
  background-color: #1087e9;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 13px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-image-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #EFEFEF;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-image-wrapper .step-image {
  width: 100%;
  height: auto;
  max-height: 280px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-image-wrapper .image-zoom-hint {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));
  color: white;
  padding: 20px 12px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-image-wrapper:hover .step-image {
  transform: scale(1.03);
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-image-wrapper:hover .image-zoom-hint {
  opacity: 1;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .text-zoom-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  padding: 6px 12px;
  border: 1px solid #EFEFEF;
  border-radius: 8px;
  background: #EFEFEF;
  color: #777;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .text-zoom-hint:hover {
  background: rgb(226.25, 226.25, 226.25);
  color: #3a3a3a;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 4px;
  margin-top: 20px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation .nav-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: 1px solid #0066B2;
  color: #0066B2;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 44px;
  min-height: 44px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation .nav-btn:hover:not(:disabled) {
  background: #0066B2;
  color: white;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation .nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  border-color: #777;
  color: #777;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation .nav-btn i {
  font-size: 12px;
}
.help-sidebar .sidebar-content .tutorial-detail .step-content .step-navigation .step-counter-nav {
  font-size: 14px;
  font-weight: 600;
  color: #3a3a3a;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .help-sidebar {
    width: 100%;
    right: -100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sidebar-overlay {
    transition: none;
  }
  .help-sidebar {
    transition: none;
  }
  .help-sidebar .tutorial-card,
  .help-sidebar .nav-btn,
  .help-sidebar .zoom-btn,
  .help-sidebar .retry-btn,
  .help-sidebar .back-btn,
  .help-sidebar .close-btn,
  .help-sidebar .search-input,
  .help-sidebar .step-image,
  .help-sidebar .step-progress-fill {
    transition: none;
    animation: none;
  }
}
::ng-deep .delete-confirm-dialog .p-dialog-header {
  background: #0066B2;
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .delete-confirm-dialog .p-dialog-header .custom-dialog-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}
::ng-deep .delete-confirm-dialog .p-dialog-header .dialog-close-btn {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
::ng-deep .delete-confirm-dialog .p-dialog-header .dialog-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg) scale(1.1);
  border-color: rgba(255, 255, 255, 0.3);
}
::ng-deep .delete-confirm-dialog .p-dialog-header .dialog-close-btn:active {
  transform: rotate(90deg) scale(0.95);
}
::ng-deep .delete-confirm-dialog .p-dialog-content {
  padding: 20px;
}
::ng-deep .delete-confirm-dialog .p-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.delete-confirm-message {
  margin: 0;
  font-size: 14px;
  color: #3a3a3a;
  line-height: 1.6;
}

.delete-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid #EFEFEF;
}
.delete-confirm-actions .btn-cancel {
  padding: 9px 20px;
  border: 1px solid #EFEFEF;
  background: white;
  color: #777;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.delete-confirm-actions .btn-cancel:hover {
  border-color: #0066B2;
  color: #0066B2;
}
.delete-confirm-actions .btn-delete {
  padding: 9px 20px;
  border: none;
  background: #e74c3c;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.delete-confirm-actions .btn-delete:hover {
  background: #c0392b;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
